import React, { useState, useEffect } from 'react';
import { useStyles, TableControl, InputContainer } from './styles';
import Layout from 'shared/component/Layout';
import TabPanel from 'shared/component/tabPanel';
import useReport from 'hook/report';
import ActionsButtons from './components/ActionsButtons';
// import ProfessionalModal from './components/ProfessionalModal';
import '../../shared/fixedtab.css';
import ContainerCollapse from './components/ContainerCollapse';
import CollapseTable from 'shared/component/CollapseTable';
import SearchInputDebounce from 'shared/component/forms/SearchInputDebounce';
import ControlledPagination from 'shared/component/ControledPagination';

export default function ReportAcessAppPage() {
  const classes = useStyles();

  const {
    history,
    pagination,
    loading,
    loadingHistory,
    getDeviceHistory,
    getDispositivev,
  } = useReport();

  const [userShiftsFilter, setUserShiftsFilter] = React.useState({
    pageUserShifts: 1,
    perPageUserShifts: 4,
  });

  const [deviceListFilter, setDeviceListFilter] = useState(() => {
    const savedPage = parseInt(localStorage.getItem('deviceListPage'), 10);
    return {
      page: !isNaN(savedPage) ? savedPage : 1,
      perPage: 10,
      search: '',
    };
  });

  const [id, setId] = useState('');
  const [seletedRow, setSelectedRow] = useState(0);
  const [openByProps, setOpenByProps] = useState(false);
  const [deviceAccess, setDeviceAccess] = useState([]);
  const [total, setTotal] = useState(0);

  const detailsRow = (deviceId) => {
    setId(deviceId);
  };
  const handlePageChange = (newPage) => {
    setDeviceListFilter((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  useEffect(() => {
    const fetchDevices = async () => {
      const response = await getDispositivev({
        page: deviceListFilter.page,
        per_page: deviceListFilter.perPage,
        search: deviceListFilter.search,
      });

      setDeviceAccess(response.items || []);
      setTotal(response.totalItems || 0);
    };

    fetchDevices();
  }, [deviceListFilter]);

  React.useEffect(() => {
    if (openByProps && id) {
      getDeviceHistory(id);
    }
  }, [openByProps, id]);

  const componentMinimizable = () => (
    <ContainerCollapse
      rowData={history} // history vem da API getDeviceHistory
      loading={loadingHistory}
      pagination={pagination}
    />
  );

  const resetPageDetails = () => {
    setUserShiftsFilter({ ...userShiftsFilter, pageUserShifts: 1 });
  };

  const handleDeviceSearch = (search) => {
    setDeviceListFilter((prev) => ({
      ...prev,
      page: 1,
      search: search || '',
    }));
  };
  useEffect(() => {
    localStorage.setItem('deviceListPage', deviceListFilter.page);
  }, [deviceListFilter.page]);

  return (
    <Layout title="Acessos ao App por dispositivo" backArrow calendarRange>
      <div className={classes.root}>
        <div
          data-cy="div_professional_filters"
          className={classes.inputContainer}
        >
          <InputContainer>
            <SearchInputDebounce
              value={deviceListFilter.search}
              className={classes.inputWidth}
              placeholder="Busque por nome ou CPF"
              onChange={handleDeviceSearch}
              style={{
                flex: 1,
                alignItems: 'center',
                height: 48,
                width: '100%',
              }}
            />
          </InputContainer>
        </div>
        <TabPanel>
          <TableControl>
            <CollapseTable
              dataList={deviceAccess}
              columns={[
                { id: 'device_id', label: 'Device ID' },
                { id: 'device_model', label: 'Modelo do Dispositivo' },
                { id: 'app_version', label: 'Versão do App' },
                { id: 'os', label: 'Sistema Operacional' },
                {
                  id: 'device_user_count',
                  label: 'Qtd. de Usuários no Dispositivo',
                },
                {
                  id: 'actions',
                  minWidth: 100,
                  render: (rowData) => (
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <ActionsButtons
                        handleDetailsPage={resetPageDetails}
                        setOpenByProps={setOpenByProps}
                        seletedRow={seletedRow}
                        openByProps={openByProps}
                        row={rowData}
                        detailRequest={detailsRow}
                        setSelectedRow={setSelectedRow}
                      />
                    </div>
                  ),
                },
              ]}
              loading={loading}
              totalList={pagination?.total_items}
              redirectTo="/cadastros/administradores/cadastrar"
              showActionsButtons={false}
              componentMinimizable={componentMinimizable}
              seletedRow={seletedRow}
              open={false}
              openByProps={openByProps}
            />
          </TableControl>
        </TabPanel>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%',
          }}
        >
          <ControlledPagination
            total={total}
            pageByProps={deviceListFilter.page}
            perPage={deviceListFilter.perPage}
            loading={loading}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </Layout>
  );
}
